import omit from 'lodash.omit';

// Global Types
import { ResetStateAction } from 'services/auth/types';

// Local Types
import { ColumnWidthsState, ColumnWidthsTypes } from './types';

// Local Constants
import { COLUMN_WIDTH_SET, COLUMN_WIDTHS_REMOVE } from './constants';

export const initialState: ColumnWidthsState = {};

export default function (
    state: ColumnWidthsState = initialState,
    action: ColumnWidthsTypes | ResetStateAction
): ColumnWidthsState {
    switch (action.type) {
        case COLUMN_WIDTH_SET: {
            const { tableId, columnName, width } = action.payload;
            if (width) {
                return {
                    ...state,
                    [tableId]: {
                        ...(state[tableId] ? state[tableId] : {}),
                        [columnName]: width
                    }
                };
            }

            return {
                ...state,
                [tableId]: omit(state[tableId], columnName)
            };
        }
        case COLUMN_WIDTHS_REMOVE: {
            const { tableId } = action.payload;
            return omit(state, tableId);
        }
        default:
            return state;
    }
}
